import React from 'react';
import { Table } from 'src/components/ui';
import { EmptyState } from 'src/components/Icons/EmptyStates';
import classnames from 'src/util/classnames';
import ToggleAllButton from '../ToggleAllButton';

class TableLayout {
  constructor({
    $id,
    hasAddBtnInRow,
    hasToolbar,
    headers,
    itemsAreObjectType,
    itemsUiSchema,
    positionButtons,
    onEmptyMessage,
    props,
    rowClassNames,
  }) {
    this.isTable = true;
    this.$id = $id;
    this.hasAddBtnInRow = hasAddBtnInRow;
    this.hasToolbar = hasToolbar;
    this.headers = headers;
    this.itemsAreObjectType = itemsAreObjectType;
    this.itemsUiSchema = itemsUiSchema;
    this.onEmptyMessage = onEmptyMessage;
    this.positionButtons = positionButtons;
    this.buttonsLeft = positionButtons === 'left';
    this.props = props;
    this.rowClassNames = rowClassNames;
  }

  wrapArray(children) {
    return (
      <Table
        striped={this.itemsUiSchema['ui:striped']}
        borderless={this.itemsUiSchema['ui:borderless']}
        hover={this.itemsUiSchema['ui:hoverEffect']}
        className={classnames('animated-show', this.itemsUiSchema['ui:classNames'])}
      >
        {children}
      </Table>
    );
  }

  wrapBody(children) {
    return (
      <tbody className="array-item-list" key={`array-item-list-${this.$id}`}>
        {children}
      </tbody>
    );
  }

  wrapLoader(children) {
    return (
      <tr className="animated-show">
        <td colSpan={100}>{children}</td>
      </tr>
    );
  }

  wrapItem(id, props, onAddClick, rowIdx, rowCount, children, buttons, rowClassNames) {
    const buttonsComp = buttons ? (
      <td className="col-xs-2 array-item-toolbox animated-show">
        <div className="btn-group w-full" style={{ display: 'flex', justifyContent: 'center' }}>
          {buttons}
        </div>
      </td>
    ) : null;

    const content = this.buttonsLeft ? (
      <>
        {buttonsComp}
        {children}
      </>
    ) : (
      <>
        {children}
        {buttonsComp}
      </>
    );

    return (
      <tr id={id} className={`animated-show ${props.className} ${this.itemsAreObjectType ? 'for-object-row' : ''} ${rowClassNames}`}>
        {content}
      </tr>
    );
  }

  wrapItemField({ name, uiSchema }, children) {
    return (
      <td key={name} className={`${(uiSchema[name] || {})['ui:cellClassName']} animated-show`}>
        {children}
      </td>
    );
  }

  wrapItemPanelRow({ columnCount }, children) {
    return (
      <tr className={`array-item animated-show panel-row ${this.rowClassNames}`}>
        {this.buttonsLeft ? <td /> : null}
        <td className="animated-show array-item-field" colSpan={columnCount}>
          {children}
        </td>
      </tr>
    );
  }

  wrapItemErrorList(children) {
    return (
      <tr className="animated-show">
        {this.buttonsLeft ? <td /> : null}
        <td className="animated-show" colSpan={this.headers?.length || 100}>
          {children}
        </td>
      </tr>
    );
  }

  makeEmptyItemField({ name }) {
    return <td key={name} />;
  }

  makeSimpleItem(props) {
    return <td className={`${this.hasToolbar ? 'col-xs-10' : 'col-xs-12'} animated-show array-item-field`}>{props.children}</td>;
  }

  wrapAddButton(children) {
    return (
      <tr>
        <td colSpan="100">
          <div className="mt-3">{children}</div>
        </td>
      </tr>
    );
  }

  makeEmptyMessage() {
    return (
      <tr className="animated-show">
        <td colSpan={this.headers?.length || 100}>
          <EmptyState size={96} message={this.onEmptyMessage} />
        </td>
      </tr>
    );
  }

  makeHeaders() {
    return (
      <thead>
        <tr className={`animated-show ${this.itemsAreObjectType ? 'for-object-row' : ''}`}>
          {this.hasAddBtnInRow ? <th /> : null}
          {this.buttonsLeft ? <th /> : null}
          {this.headers.map(({ field, Component, text, toggleAll }, idx) => (
            <th
              key={idx}
              className={classnames((this.itemsUiSchema[field] || {})['ui:cellClassName'], (this.itemsUiSchema[field] || {})['ui:headerClassName'])}
            >
              {toggleAll ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
                  {Component ? <Component field={field} {...this.props} /> : text}
                  <ToggleAllButton field={field} {...this.props} />
                </div>
              ) : Component ? (
                <Component field={field} {...this.props} />
              ) : (
                text
              )}
            </th>
          ))}
          {this.hasToolbar ? <th /> : null}
        </tr>
      </thead>
    );
  }
}

export default TableLayout;
